var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "search-load",
      attrs: { title: "Загрузить список ИНН, ОГРН или ОКПО" },
    },
    [
      _c("i", {
        staticClass: "lnr lnr-text-align-justify",
        on: { click: _vm.modalClick },
      }),
      _vm._v(" "),
      _vm.modalDisplay
        ? _c("div", { staticClass: "search-list" }, [
            _c("h6", [_vm._v("Загрузка кодов для формирования списка")]),
            _vm._v(" "),
            _c("div", { staticClass: "search-list-holder" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.idlist,
                    expression: "idlist",
                  },
                ],
                attrs: {
                  placeholder:
                    "ИНН, ОГРН или ОКПО, не более 500 кодов, каждый с новой строки",
                },
                domProps: { value: _vm.idlist },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.idlist = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "search-list-submit",
                staticStyle: { "margin-top": "40px" },
                on: { click: _vm.uploadHandle },
              },
              [_vm._v("Найти по списку")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "search-list-close",
                staticStyle: {
                  color: "#c00",
                  cursor: "pointer",
                  "margin-top": "20px",
                },
                on: { click: _vm.modalClick },
              },
              [_vm._v("× Закрыть")]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }